import { IUserMentionData } from '@gem/models/commonModel';
import { isMentionAll } from '@gem/utils';

import MentionAllPopover from 'APP/main/ChatView/components/MentionAllPopover';
import { useUserProfile } from 'APP/main/hooks/userProfile/useUserProfile';

import { IRenderer } from '../renderTree.types';
import styles from './MentionRenderer.styles.m.css';

interface IMentionRendererOptions {
  mention: IUserMentionData;
}

export const MentionRenderer: IRenderer<IMentionRendererOptions> = (props) => {
  const { children, options } = props;
  const userProfile = useUserProfile(options.mention?.userId);

  if (!children) {
    return null;
  }

  if (isMentionAll(options.mention.nickname)) {
    return (
      <span>
        <MentionAllPopover
          title={children}
          mention={options.mention}
          className={styles.mentionedUser}
        />
      </span>
    );
  }

  return (
    <span>
      <button
        className={styles.mentionedUser}
        title={children as string}
        onClick={userProfile.show}
      >
        {children}
      </button>
    </span>
  );
};
